import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { completedCrop })=>({
        ReactCrop: {
            position: 'relative',
            display: 'inline-block',
            cursor: 'crosshair',
            maxWidth: '100%',
            '& .ReactCrop__crop-mask': {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                pointerEvents: 'none'
            },
            '& .ReactCrop__crop-selection': {
                position: 'absolute',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.5)'
            },
            '& .ReactCrop__drag-handle': {
                width: '10px',
                height: '10px',
                backgroundColor: '#fff',
                border: '1px solid rgba(0,0,0,0.5)',
                position: 'absolute'
            },
            '& .ReactCrop__drag-handle.ord-n': {
                display: 'none'
            },
            '& .ReactCrop__drag-handle.ord-e': {
                display: 'none'
            },
            '& .ReactCrop__drag-handle.ord-s': {
                display: 'none'
            },
            '& .ReactCrop__drag-handle.ord-w': {
                display: 'none'
            },
            '& .ReactCrop__drag-handle.ord-nw': {
                top: '-5px',
                left: '-5px',
                cursor: 'nw-resize'
            },
            '& .ReactCrop__drag-handle.ord-ne': {
                top: '-5px',
                right: '-5px',
                cursor: 'ne-resize'
            },
            '& .ReactCrop__drag-handle.ord-se': {
                bottom: '-5px',
                right: '-5px',
                cursor: 'se-resize'
            },
            '& .ReactCrop__drag-handle.ord-sw': {
                bottom: '-5px',
                left: '-5px',
                cursor: 'sw-resize'
            },
            '& .ReactCrop__crop-selection:not(.ReactCrop--no-animate .ReactCrop__crop-selection)': {
                animation: '$marchingAnts 1s linear infinite',
                backgroundImage: "linear-gradient(to right, #fff 50%, #444 50%),linear-gradient(to right, #fff 50%, #444 50%),linear-gradient(to bottom, #fff 50%, #444 50%),linear-gradient(to bottom, #fff 50%, #444 50%)",
                backgroundSize: '10px 1px, 10px 1px, 1px 10px, 1px 10px',
                backgroundPosition: '0 0, 0 100%, 0 0, 100% 0',
                backgroundRepeat: 'repeat-x, repeat-x, repeat-y, repeat-y'
            }
        },
        '@keyframes marchingAnts': {
            '0%': {
                backgroundPosition: '0 0, 0 100%, 0 0, 100% 0'
            },
            '100%': {
                backgroundPosition: '10px 0, -10px 100%, 0 -10px, 100% 10px'
            }
        },
        cropContainer: {
            position: 'relative',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        cropImage: {
            maxWidth: '100%',
            maxHeight: '100%',
            display: 'block'
        },
        canvasPreview: {
            display: 'none',
            border: '1px solid black',
            objectFit: 'contain',
            width: null == completedCrop ? void 0 : completedCrop.width,
            height: null == completedCrop ? void 0 : completedCrop.height
        }
    }));
export { useStyles };
